module.exports = __webpack_public_path__ + "img/lightning.4333663d.svg";